import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/index'
// components
import { Modal } from 'components/UI'
import ScaleOptionForm from '../Form'
// hooks
import { useModalData } from 'hooks/index'
// themes
import { colors } from 'themes/index'
import { CloseIcon } from 'components/UI/Icons'

const PAPER_PROPS = {
  style: {
    padding: '16px'
  }
}

export const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
`

const ScaleOptionCreateModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, addOption }
  } = useModalData({ modalType: Modals.SCALE_OPTION_CREATE_MODAL })

  const handleSubmit = async (data) => {
    await addOption(data)
    hideModal()
  }

  const initialValues = {
    active: true
  }

  return (
    <Modal
      width={'xs'}
      hideBackdrop
      isOpen={isOpen}
      disableRestoreFocus
      disableBackdropClick
      disableEscapeKeyDown
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        <span>Create Scale Option</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <ScaleOptionForm hideModal={hideModal} initialValues={initialValues} onSubmit={handleSubmit} />
    </Modal>
  )
}

export default ScaleOptionCreateModal
